import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { LogZoppy } from '../../../../shared/services/responses/integracao-zoppy/get-config-zoppy.response';

@Component({
    selector: 'app-integracao-zoppy-detalhe-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './integracao-zoppy-detalhe-dialog.component.html',
    styleUrls: ['./integracao-zoppy-detalhe-dialog.component.css']
})
export class IntegracaoZoppyDetalheDialogComponent {

    log: LogZoppy;
    formattedRequest: string = '';
    formattedResponse: string = '';
    isRequestJson: boolean = false;
    isResponseJson: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { log: LogZoppy },
        public dialogRef: MatDialogRef<IntegracaoZoppyDetalheDialogComponent>
    ) {
        this.log = data.log;
        this.formattedRequest = this.tryFormatJson(this.log.zoppyRequest);
        this.formattedResponse = this.tryFormatJson(this.log.zoppyResponse);
        this.isRequestJson = this.isValidJson(this.log.zoppyRequest);
        this.isResponseJson = this.isValidJson(this.log.zoppyResponse);
    }

    close(): void {
        this.dialogRef.close();
    }

    formatDate(date: Date | string | null): string {
        if (!date) return '-';
        const d = new Date(date);
        return d.toLocaleString('pt-BR');
    }

    private tryFormatJson(value: string): string {
        if (!value) return '-';
        try {
            const parsed = JSON.parse(value);
            return JSON.stringify(parsed, null, 2);
        } catch {
            return value;
        }
    }

    private isValidJson(value: string): boolean {
        if (!value) return false;
        try {
            JSON.parse(value);
            return true;
        } catch {
            return false;
        }
    }

    getBadgeClass(idTipoLog: number): string {
        switch (idTipoLog) {
            case 1: return 'badge-vermelho'; // Erro
            case 2: return 'badge-verde';    // Sucesso
            case 3: return 'badge-amarelo';  // Alerta
            default: return 'badge-cinza';
        }
    }
}
